import { useTranslation } from "react-i18next";import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../../services/api';
import { BellIcon, BellAlertIcon, XMarkIcon } from '@heroicons/react/24/outline';

const NotificationBell = () => {const { t } = useTranslation();
  const [announcements, setAnnouncements] = useState([]);
  const [open, setOpen] = useState(false);
  const [unread, setUnread] = useState(0);
  const panelRef = useRef(null);
  const navigate = useNavigate();

  useEffect(() => {
    fetchAnnouncements();
  }, []);

  // Close on outside click
  useEffect(() => {
    const handleClick = (e) => {
      if (panelRef.current && !panelRef.current.contains(e.target)) {
        setOpen(false);
      }
    };
    if (open) document.addEventListener('mousedown', handleClick);
    return () => document.removeEventListener('mousedown', handleClick);
  }, [open]);

  const fetchAnnouncements = async () => {
    try {
      const role = window.location.pathname.includes('/owner/') ? 'owner' : 'tenant';
      const { data } = await api.get(`/portal/${role}/announcements`);
      if (data.success) {
        const items = data.announcements || [];
        setAnnouncements(items.slice(0, 6));
        const lastSeenAt = localStorage.getItem('aps_notif_seen_at');
        if (!lastSeenAt) {
          setUnread(items.length);
        } else {
          const lastDate = new Date(lastSeenAt);
          const unreadCount = items.filter((a) => new Date(a.created_at) > lastDate).length;
          setUnread(unreadCount);
        }
      }
    } catch {

      // Silently fail — non-critical
    }};

  const handleOpen = () => {
    setOpen((prev) => !prev);
    if (!open && unread > 0) {
      localStorage.setItem('aps_notif_seen_at', new Date().toISOString());
      setUnread(0);
    }
  };

  const handleViewAll = () => {
    setOpen(false);
    const role = window.location.pathname.includes('/owner/') ? 'owner' : 'tenant';
    navigate(`/portal/${role}/announcements`);
  };

  const timeAgo = (date) => {
    const seconds = Math.floor((new Date() - new Date(date)) / 1000);
    if (seconds < 60) return 'just now';
    const mins = Math.floor(seconds / 60);
    if (mins < 60) return `${mins}m ago`;
    const hours = Math.floor(mins / 60);
    if (hours < 24) return `${hours}h ago`;
    return `${Math.floor(hours / 24)}d ago`;
  };

  return (
    <div className="relative" ref={panelRef}>
            <button
        onClick={handleOpen}
        className="relative p-2 text-gray-400 hover:text-gray-600 dark:hover:text-gray-200 transition-colors rounded-lg hover:bg-gray-100 dark:hover:bg-gray-700"
        title="Announcements"
        aria-label={`${unread} unread announcements`}>
        
                {unread > 0 ?
        <BellAlertIcon className="w-6 h-6 text-primary-600 dark:text-primary-400 animate-[wiggle_1s_ease-in-out_infinite]" /> :
        <BellIcon className="w-6 h-6" />
        }
                {unread > 0 &&
        <span className="absolute -top-0.5 -right-0.5 flex h-5 w-5 items-center justify-center rounded-full bg-primary-600 text-[10px] font-bold text-white ring-2 ring-white dark:ring-gray-800">
                        {unread > 9 ? '9+' : unread}
                    </span>
        }
            </button>

            {/* Dropdown Panel */}
            {open &&
      <div className="absolute right-0 mt-2 w-80 bg-white dark:bg-gray-800 rounded-xl border border-gray-200 dark:border-gray-700 shadow-xl z-50 overflow-hidden animate-fade-in-up">
                    <div className="flex items-center justify-between px-4 py-3 border-b border-gray-100 dark:border-gray-700">
                        <span className="text-sm font-bold text-gray-900 dark:text-white">{t("announcements")}</span>
                        <button onClick={() => setOpen(false)} className="text-gray-400 hover:text-gray-600 dark:hover:text-gray-200">
                            <XMarkIcon className="w-4 h-4" />
                        </button>
                    </div>

                    <div className="max-h-80 overflow-y-auto divide-y divide-gray-50 dark:divide-gray-700">
                        {announcements.length === 0 ?
          <div className="py-8 text-center text-sm text-gray-400">
                                <BellIcon className="w-8 h-8 mx-auto mb-2 opacity-30" />
                                {t("no_announcements_yet")}
                            </div> :

          announcements.map((a) =>
          <div key={a.id} className="px-4 py-3 hover:bg-gray-50 dark:hover:bg-gray-700/50 cursor-pointer transition-colors" onClick={handleViewAll}>
                                    <p className="text-sm font-semibold text-gray-900 dark:text-white truncate">{a.title}</p>
                                    <p className="text-xs text-gray-500 dark:text-gray-400 mt-0.5 line-clamp-2">{a.content}</p>
                                    <p className="text-[10px] text-gray-400 mt-1">{timeAgo(a.created_at)}</p>
                                </div>
          )
          }
                    </div>

                    <div className="px-4 py-3 border-t border-gray-100 dark:border-gray-700 bg-gray-50 dark:bg-gray-800/50">
                        <button onClick={handleViewAll} className="w-full text-center text-xs font-semibold text-primary-600 dark:text-primary-400 hover:text-primary-700 dark:hover:text-primary-300 transition-colors">
                            {t("view_all_announcements")}
                        </button>
                    </div>
                </div>
      }
        </div>);

};

export default NotificationBell;